import { useTranslation } from 'react-i18next';
import { StepProgress } from '@/components/common/StepProgress';
import { IconSignIn, IconCreditCard, IconCheck, IconDeviceMobile } from '@tabler/icons-react';
import { ScrollToPlansButton } from "@/components/common/ScrollToPlansButton";
import { PurchaseButton } from "@/components/common/PurchaseButton";

export default function PurchaseSteps({ onPurchase }: { onPurchase: (planId: string) => void }) {
  const { t } = useTranslation('common');

  return (
    <section className="py-8 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-2 mx-auto max-w-2xl">
          <h2 className="text-3xl md:text-4xl font-semibold text-slate-900 leading-snug md:leading-snug px-8 md:px-0">
            {t('purchase.howToPurchase')}
          </h2>
        </div>

        <div className="max-w-md mx-auto">
          <StepProgress currentStep={1} fontSize="base" />
        </div>

        <div className="bg-white border border-slate-200 rounded-xl mt-4">
          <div className="grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-slate-200">
            <div className="px-6 pt-5 md:pt-8 pb-7 flex flex-row md:flex-col items-center gap-4">
              <div className="mb-0 md:mb-2 w-10 h-10 md:w-16 md:h-16 bg-sky-500 rounded-full flex items-center justify-center shrink-0">
                <IconCreditCard className="w-6 md:w-8 h-6 md:h-8 text-white" />
              </div>
              <div className="flex flex-col items-start md:items-center gap-1 md:gap-3">
                <h3 className="text-slate-900 leading-relaxed text-lg md:text-2xl text-left font-semibold">
                  1. {t('steps.checkout')}
                </h3>
                <p className="text-base md:text-base text-slate-500 text-left mx-auto leading-relaxed md:leading-relaxed">
                  {t('purchase.checkoutDescription')}
                </p>
              </div>
            </div>

            <div className="px-6 pt-5 md:pt-8 pb-7 flex flex-row md:flex-col items-center gap-4">
              <div className="mb-0 md:mb-2 w-10 h-10 md:w-16 md:h-16 bg-sky-500 rounded-full flex items-center justify-center shrink-0">
                <IconCheck className="w-6 md:w-8 h-6 md:h-8 text-white" />
              </div>
              <div className="flex flex-col items-start md:items-center gap-1 md:gap-3">
                <h3 className="text-slate-900 leading-relaxed text-lg md:text-2xl text-left font-semibold">
                  2. {t('steps.success')}
                </h3>
                <p className="text-base md:text-base text-slate-500 text-left mx-auto leading-relaxed md:leading-relaxed">
                  {t('purchase.successDescription')}
                </p>
              </div>
            </div>

            <div className="px-6 pt-5 md:pt-8 pb-7 flex flex-row md:flex-col items-center gap-4">
              <div className="mb-0 md:mb-2 w-10 h-10 md:w-16 md:h-16 bg-sky-500 rounded-full flex items-center justify-center shrink-0">
                <IconDeviceMobile className="w-6 md:w-8 h-6 md:h-8 text-white" />
              </div>
              <div className="flex flex-col items-start md:items-center gap-1 md:gap-3">
                <h3 className="text-slate-900 text-lg md:text-2xl text-left font-semibold">
                  3. {t('steps.activate')}
                </h3>
                <p className="text-base md:text-base text-slate-500 text-left mx-auto leading-relaxed md:leading-relaxed">
                  {t('purchase.activateDescription')}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* <PurchaseButton onPurchase={onPurchase} /> */}

      </div>
    </section>
  );
}